import React from 'react';
import {testScores} from '../../ducks/index';
import {connect} from 'react-redux';
import {duckify, filterDuck} from "../../utils/duckify";
import './styles/test_scores.scss';
import {titleize} from '../../utils/strings';
import { ensureKeyed } from 'utils';

class TestScoreViewer extends React.Component {

  static defaultProps = {
    testScores: {},
    contactId: null
  };

  constructor() {
    super();
  };


  render() {
    const {testScores} = this.props;
    if (testScores.ready && testScores.length > 0) {
      // Iterate through each type and render a table for each
      return (<div>
        {scoreSubTypes.map((type) => {
          let scores = filterScores(testScores, type);
          let sortedScores = scores.sort((x, y) => new Date(x.date) > new Date(y.date));
          if (scores && scores.length > 0) {
            return (<TestScoreTable testScores={sortedScores} type={type}/>);
          } else {
            return (<React.Fragment/>);
          }
        }).map(ensureKeyed())} </div>);
    } else {
      return null
    }
  }
}


class TestScoreTable extends React.Component {

  static defaultProps = {
    testScores: {},
  };

  constructor() {
    super();
  };

  render() {
    const {testScores, type} = this.props;
    const excludeKeys = ['_type', 'id'];
    return (<div className={'test-score-group'}>
      <div className={'test-score-header'}>{type}</div>
      <table className={'table table-striped test-score-table'}>
        <colgroup>
          <col style={{width: '40%'}}/>
          <col style={{width: '20%'}}/>
        </colgroup>
        <tbody className={'left'}>
        { Object.keys(testScores[0])
        .filter((scoreName) => !excludeKeys.includes(scoreName))
        .map((scoreName) => <tr>
          <td className={'score-name'}>{prettify(scoreName)}</td>
          {testScores.map((score) => {
            return (<td className={'divider score'}>{score[scoreName]}</td>)
          }).map(ensureKeyed())}
        </tr>).map(ensureKeyed())}
        </tbody>
      </table>
    </div>)
  }
}

const scoreSubTypes = ['Test Score', 'SSAT Scores' ];
const scorePrefixes = ['Ssatb'];


const filterScores = (scores, type) => {
  let newScores = scores.filter((score) => {
    return score['_type'] === type;
  });
  return newScores;
};

const prettify = (scoreName) => {
  let name = titleize(scoreName);
  scorePrefixes.forEach((type) => {  name = name.replace(type, '')});
  return name
};


const mapDucksToProps = (ownProps) => ({ testScores: filterDuck(testScores, {contact_id: ownProps.contactId} ) });

export default duckify(mapDucksToProps)(TestScoreViewer);
